export const GLOBAL_WINDOW_KANBAN_BOARD_CARD_MOUSE_DOWN_TIME_START =
  "KANBAN_BOARD_CARD_MOUSE_DOWN_TIME_START";

/**
 * NOTE
 *
 * Represents the active widgets in the global dialer context.
 *
 * This variable ensures that the leads queue remains paused
 * until the widget is closed.
 */
export const GLOBAL_STATE_VAR_ACTIVE_WIDGETS =
  "GLOBAL_STATE_VAR_ACTIVE_WIDGETS";

/**
 * Used as datadog debugger variable which contains all
 * global dialer state variables
 */
export const GLOBAL_DIALER_STATE = "GLOBAL_DIALER_STATE";

/**
 * Used as datadog debugger variable which contains the
 * timestamp when WS CONNECTED event was fired
 */
export const GLOBAL_DEBUG_CALL_STATUS_UPDATE_CONNECTED_AT =
  "GLOBAL_DEBUG_CALL_STATUS_UPDATE_CONNECTED_AT";

/**
 * Used as datadog debugger variable which contains the
 * timestamp when TWILIO INCOMING CALL RECEIVED event was fired
 */
export const GLOBAL_DEBUG_TWILIO_INCOMING_CALL_RECEIVED_AT =
  "GLOBAL_DEBUG_TWILIO_INCOMING_CALL_RECEIVED_AT";

/**
 *
 * Contains all websocket instances
 */
export const GLOBAL_WS_INSTANCES = "GLOBAL_WS_INSTANCES";
